const NotFound = () => {
  return (
    <div className="center-outside-div">
      <div className="heading-1">404 Not Found!</div>
    </div>
  );
};

export default NotFound;
